import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';

export function AdminRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  console.log('🛡️ AdminRoute - Estados:', {
    isAuthenticated,
    isLoading,
    userRole: user?.role,
    pathname: location.pathname
  });

  // Loading state
  if (isLoading) {
    console.log('⏳ AdminRoute - Mostrando loading');
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: 'background.default'
        }}
      >
        <CircularProgress size={60} sx={{ color: 'primary.main', mb: 2 }} />
        <Typography variant="h6" color="text.secondary">
          Verificando permissões...
        </Typography>
      </Box>
    );
  }

  // Se não estiver autenticado, redirecionar para login
  if (!isAuthenticated) {
    console.log('🚫 AdminRoute - Redirecionando para login');
    return (
      <Navigate 
        to="/login" 
        state={{ from: location }} 
        replace 
      />
    );
  }

  // Se autenticado mas não for admin, mostrar erro
  if (user?.role !== 'admin') {
    console.log('🚫 AdminRoute - Acesso negado - não é admin');
    return (
      <Box sx={{ p: 3, minHeight: '100vh', backgroundColor: 'background.default', pt: '80px' }}>
        <Alert 
          severity="error" 
          sx={{ 
            maxWidth: 'md', 
            mx: 'auto',
            fontSize: '1rem'
          }}
        >
          <Typography variant="h6" gutterBottom>
            Acesso Negado
          </Typography>
          <Typography variant="body1">
            Esta página é restrita apenas para administradores. 
            Você está logado como <strong>{user?.role === 'secretary' ? 'Secretária' : 'Usuário'}</strong>.
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            <strong>Precisa de acesso administrativo?</strong> Entre em contato com o administrador do sistema.
          </Typography>
        </Alert>
      </Box>
    );
  }

  // Se autenticado e for admin, renderizar o componente filho
  console.log('✅ AdminRoute - Admin autenticado, renderizando children');
  return children;
}